import { render, staticRenderFns } from "./TableContact.vue?vue&type=template&id=720e1191&"
import script from "./TableContact.js?vue&type=script&lang=js&"
export * from "./TableContact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports